import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgListBullets = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.75 7a.875.875 0 0 1 .875-.875h14a.875.875 0 1 1 0 1.75h-14A.875.875 0 0 1 8.75 7Zm14.875 6.125h-14a.875.875 0 0 0 0 1.75h14a.875.875 0 1 0 0-1.75Zm0 7h-14a.875.875 0 0 0 0 1.75h14a.875.875 0 1 0 0-1.75ZM4.812 5.687a1.313 1.313 0 1 0 0 2.626 1.313 1.313 0 0 0 0-2.626Zm0 7a1.313 1.313 0 1 0 0 2.626 1.313 1.313 0 0 0 0-2.626Zm0 7a1.313 1.313 0 1 0 0 2.626 1.313 1.313 0 0 0 0-2.625Z" />
  </svg>
);
export default SvgListBullets;
